import { render, staticRenderFns } from "./ColorfulTitle.vue?vue&type=template&id=07af7d42"
import script from "./ColorfulTitle.vue?vue&type=script&lang=js"
export * from "./ColorfulTitle.vue?vue&type=script&lang=js"
import style0 from "./ColorfulTitle.vue?vue&type=style&index=0&id=07af7d42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports